import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    padding: '2em',
    backgroundColor: theme.palette.grey[200],
    width: '100%'
  },
  paper: {
    padding: '1em',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)'
  },
  loading: { height: '100vh' },
  pushRight: {
    marginRight: theme.spacing(1)
  },
  link: {
    color: theme.palette.info.main,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.info.light
    }
  },
  box: {
    marginTop: theme.spacing(3)
  }
}))